import { marketLibraryStoreApp, marketLibraryManageDataStoreApp, marketLibraryStorePhy, marketLibraryManageDataStorePhy } from 'stores/marketLibrary'
import { uploadStatusStore } from 'stores/uploadStatus'

export function handleUploadMarketDataMessage(data) {
  if (data.notify) {
    marketLibraryStoreApp.refetch()
    marketLibraryManageDataStoreApp.refetch()

    marketLibraryStorePhy.refetch()
    marketLibraryManageDataStorePhy.refetch()
    uploadStatusStore.refetch('MARKET_DATA')
  }
}
